import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Button,
  Divider,
  Dropdown,
  DropdownDivider,
  DropdownHeader,
  DropdownItem,
  DropdownMenu,
  Form,
  Icon,
  Input,
  Loader,
  Message,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from 'semantic-ui-react'
import history from '~/services/history'

import { toast } from 'react-toastify'
import api from '~/services/api'
import TicketComments from '../../components/TicketComments'
import { useGlobalContext } from '../../contexts/GlobalContext'
import { ContainerTabulacao, FormContainer } from './styles'

function convertToFullPathList(tabs, parentPath) {
  const result = []
  for (const tab of tabs) {
    const currentPath = parentPath ? `${parentPath} ⇒ ${tab.nome}` : tab.nome
    if (tab.tabulations?.length === 0) {
      result.push({
        id: tab.id,
        nome: currentPath,
        ativo: tab.ativo,
        texto_template: tab.texto_template,
        use_template: tab.use_template,
      })
    }

    if (tab.tabulations?.length) {
      result.push(...convertToFullPathList(tab.tabulations, currentPath))
    }
  }

  return result.sort((a, b) => {
    if (a.nome < b.nome) return -1
    if (a.nome > b.nome) return 1
    return 0
  })
}

function findItemNameById(id, estrutura) {
  for (let i = 0; i < estrutura.length; i++) {
    if (estrutura[i].id === id) {
      return estrutura[i].nome
    }

    if (estrutura[i].tabulations.length > 0) {
      const result = findItemNameById(id, estrutura[i].tabulations)
      if (result) return result
    }
  }
}

// const options = [
//   {
//     key: 1,
//     value: 1,
//     text: 'Aberto',
//     label: { color: 'green', empty: true, circular: true },
//   },
//   {
//     key: 2,
//     value: 2,
//     text: 'Fechado',
//     label: { color: 'black', empty: true, circular: true },
//   },
//   {
//     key: 3,
//     value: 3,
//     text: 'Pendente',
//     label: { color: 'yellow', empty: true, circular: true },
//   },
// ]

export default function Ticket({ match }) {
  const [listStatus, setListStatus] = useState([])
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  const [uploadProgress, setUploadProgress] = useState(0)
  const [isUploading, setIsUploading] = useState(false)

  const { globalDispatch } = useGlobalContext()

  const [ticket, setTicket] = useState({})
  const [loading, setLoading] = useState(false)
  const [tabulations, setTabulations] = useState([])

  const profile = useSelector((state) => state.user.profile)
  const { id } = match.params

  const [tabulacao, setTabulacaoLocal] = useState(null)
  const [status, setStatus] = useState()
  const [comentario, setComentario] = useState('')

  const [deDID, setDeDid] = useState('')
  const [deDescricao, setDeDescricao] = useState('')

  const [paraDID, setParaDid] = useState('')
  const [paraDescricao, setParaDescricao] = useState('')

  const getTicket = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await api.get(`/tickets/${id}`)

      data.inicio = data.inicio
        ? moment(data.inicio).format('DD/MM/YYYY HH:mm:ss')
        : ''
      data.termino = data.termino
        ? moment(data.termino).format('DD/MM/YYYY HH:mm:ss')
        : ''

      setTicket(data)
      setLoading(false)
    } catch (error) {
      toast.error('Erro ao carregar o ticket')
      setLoading(false)
    }
  }, [id])

  const getTabulations = useCallback(async () => {
    try {
      const { data } = await api.get(`/tabulacao/domain/${profile.id_dominio}`)
      setTabulations(data)
    } catch (error) {
      toast.error('Erro ao carregar as tabulações')
    }
  }, [profile.id_dominio])

  useEffect(() => {
    setStatus(ticket.aberto)
    // setComentario(ticket.comentario)
    setTabulacaoLocal(ticket.fk_id_tabulacao)

    if (ticket.de && typeof ticket.de === 'string') {
      setDeDid(ticket.de)
    }
    if (ticket.de && typeof ticket.de === 'object') {
      setDeDid(ticket.de.did)
      setDeDescricao(ticket.de.descricao)
    }

    if (ticket.para && typeof ticket.para === 'string') {
      setParaDid(ticket.para)
    }
    if (ticket.para && typeof ticket.para === 'object') {
      setParaDid(ticket.para.did)
      setParaDescricao(ticket.para.descricao)
    }
  }, [ticket])

  useEffect(() => {
    getTicket()
    getTabulations()
  }, [getTicket, getTabulations])

  async function handleSubmit() {
    const data = {
      id,
      comentario,
      aberto: status,
      fk_id_tabulacao: tabulacao,
    }

    await api.put(`/tickets/${id}`, data)
    if (comentario.trim() !== '') {
      await api.post('/comments', {
        comentario,
        fk_id_chamado: id,
        fk_id_usuario: profile.id,
        fk_id_dominio: profile.id_dominio,
      })
    }

    globalDispatch({
      type: 'SET_TICKET',
      payload: { ticket: [] },
    })

    toast.success('Ticket atualizado com sucesso')
    history.push('/chamados')
  }

  const handleDropdownClick = () => {
    setSearchTerm('')
    setIsDropdownOpen((prev) => !prev)
  }

  const handleInputClick = (e) => {
    e.stopPropagation() // Impede que o clique no Input feche o Dropdown
    setIsDropdownOpen(true)
  }

  const handleBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDropdownOpen(false) // Fecha o Dropdown apenas se clicar fora
    }
  }

  function ajustarAlturaTextAreas() {
    const textarea = document.querySelector('#textAreaCommentEdit')
    textarea.style.height = 'auto'
    textarea.style.height = `${textarea.scrollHeight}px`
  }

  const getStatusList = useCallback(async () => {
    const { data } = await api.get(
      `/domains/${profile.id_dominio}/ticketstatus`,
    )
    setListStatus(
      data.map((status) => {
        return {
          key: status.id,
          value: status.id,
          text: status.nome,
          label: { color: status.color, empty: true, circular: true },
        }
      }),
    )
  }, [profile])

  useEffect(() => {
    getStatusList()
  }, [getStatusList])

  return (
    <FormContainer>
      {!loading ? (
        <Form onSubmit={handleSubmit}>
          <Message style={{ flex: 1 }}>
            <Form.Input name="id" value={id} label="ID:" readOnly />
            <Form.Input
              name="callid"
              value={ticket.call_id}
              label="CallID:"
              readOnly
            />

            {profile.tipo >= 2 && (
              // biome-ignore lint/a11y/useMediaCaption: <explanation>
              <audio
                controls
                src={`https://api.cloudcom.com.br/basix/recording/callid/${ticket.call_id}`}
                type="audio/mp3"
              />
            )}
            <Divider />
            <Form.Group widths="equal">
              <Form.Input name="inicio" value={ticket.inicio} label="Inicio:" />
              <Form.Input
                name="termino"
                value={ticket.termino}
                label="Termino:"
              />
              <Form.Select
                fluid
                name="status"
                label="Status:"
                options={listStatus}
                placeholder="Selecione uma opção"
                value={status}
                onChange={(e, v) => setStatus(v.value)}
              />
            </Form.Group>

            <Divider />

            {typeof ticket.de === 'string' && (
              // <Form.Input
              //   name="de.did"
              //   placeholder="Origem"
              //   label="Origem:"
              //   value={deDID}
              //   readOnly
              // />
              <Form.Group widths="equal">
                <div className="field">
                  <label htmlFor="deDid">Origem:</label>
                  <div
                    id="deDid"
                    className="ui input"
                    style={{
                      padding: '9.5px 14px',
                      backgroundColor: '#fff',
                      borderRadius: '5px',
                      border: '1px solid rgba(34, 36, 38, .15)',
                      lineHeight: '1.21428571em',
                      // color: '#0000EE',
                    }}
                  >
                    {deDID}
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="deDid">Ações:</label>
                  <div
                    className="field"
                    style={{
                      display: 'flex',
                      gap: '5px',
                      alignItems: 'end',
                      justifyContent: 'space-around',
                      backgroundColor: '#fff',
                      border: '1px solid rgba(34, 36, 38, .15)',
                      padding: '3.5px 0px',
                      borderRadius: '5px',
                    }}
                  >
                    <Link to={`/contatos/add?did=${deDID}&ticket=${id}`}>
                      <Button size="mini" type="button" positive>
                        Adicionar
                      </Button>
                    </Link>
                    <Link to={`/contatos/merge?did=${deDID}&ticket=${id}`}>
                      <Button size="mini" type="button" color="brown">
                        Mesclar contato
                      </Button>
                    </Link>
                  </div>
                </div>
              </Form.Group>
            )}
            {typeof ticket.para === 'string' && (
              // <Form.Input
              //   name="para"
              //   placeholder="Destino"
              //   label="Destino:"
              //   value={paraDID}
              //   readOnly
              // />
              <Form.Group widths="equal">
                <div className="field">
                  <label htmlFor="deDid">Destino:</label>
                  <div
                    id="deDid"
                    className="ui input"
                    style={{
                      padding: '9.5px 14px',
                      backgroundColor: '#fff',
                      borderRadius: '5px',
                      border: '1px solid rgba(34, 36, 38, .15)',
                      lineHeight: '1.21428571em',
                      // color: '#0000EE',
                    }}
                  >
                    {paraDID}
                  </div>
                </div>

                <div className="field">
                  <label htmlFor="deDid">Ações:</label>
                  <div
                    className="field"
                    style={{
                      display: 'flex',
                      gap: '5px',
                      alignItems: 'end',
                      justifyContent: 'space-around',
                      backgroundColor: '#fff',
                      border: '1px solid rgba(34, 36, 38, .15)',
                      padding: '3.5px 0px',
                      borderRadius: '5px',
                    }}
                  >
                    <Link to={`/contatos/add?did=${paraDID}&ticket=${id}`}>
                      <Button size="mini" type="button" positive>
                        Adicionar
                      </Button>
                    </Link>
                    <Link to={`/contatos/merge?did=${paraDID}&ticket=${id}`}>
                      <Button size="mini" type="button" color="brown">
                        Mesclar contato
                      </Button>
                    </Link>
                  </div>
                </div>
              </Form.Group>
            )}

            <div className="field" style={{ marginLeft: '8px' }}>
              {typeof ticket.de === 'object' && (
                <Form.Group widths="equal">
                  <Link
                    to={`/contato/${ticket.de.id}`}
                    style={{ width: '100%' }}
                  >
                    <div className="field">
                      <label htmlFor="deDid">Origem:</label>
                      <div
                        id="deDid"
                        className="ui input"
                        style={{
                          padding: '9.5px 14px',
                          backgroundColor: '#fff',
                          borderRadius: '5px',
                          border: '1px solid rgba(34, 36, 38, .15)',
                          lineHeight: '1.21428571em',
                          color: '#0000EE',
                        }}
                      >
                        {deDID}
                      </div>
                    </div>
                  </Link>

                  <Form.Input
                    name="de.descricao"
                    placeholder="Nome"
                    label="Nome:"
                    value={deDescricao}
                    readOnly
                  />
                </Form.Group>
              )}
            </div>

            <div className="field" style={{ marginLeft: '8px' }}>
              {typeof ticket.para === 'object' && (
                <Form.Group widths="equal">
                  {/* <Link
                    to={`/contato/${ticket.para.id}`}
                    style={{ width: '100%' }}
                  > */}
                  <div className="field">
                    <label htmlFor="deDid">Destino:</label>
                    <div
                      id="deDid"
                      className="ui input"
                      style={{
                        padding: '9.5px 14px',
                        backgroundColor: '#fff',
                        borderRadius: '5px',
                        border: '1px solid rgba(34, 36, 38, .15)',
                        lineHeight: '1.21428571em',
                        // color: '#0000EE',
                      }}
                    >
                      {paraDID}
                    </div>
                  </div>
                  {/* </Link> */}
                  <Form.Input
                    name="para.descricao"
                    placeholder="Nome"
                    label="Nome:"
                    value={paraDescricao}
                    readOnly
                  />
                </Form.Group>
              )}
            </div>

            <Divider />

            <div>
              {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
              <label>Tabulacao</label>
              <ContainerTabulacao>
                <strong>
                  {convertToFullPathList(tabulations, '').find(
                    (item) => item.id === tabulacao,
                  )?.nome ?? 'Selecione uma tabulação'}
                </strong>
                <Dropdown
                  text={
                    findItemNameById(tabulacao, tabulations) ??
                    'Selecione uma tabulação'
                  }
                  open={isDropdownOpen}
                  onClick={handleDropdownClick}
                  onBlur={handleBlur}
                  icon="filter"
                  floating
                  labeled
                  button
                  className="icon"
                >
                  <DropdownMenu>
                    <Input
                      icon="search"
                      iconPosition="left"
                      className="search"
                      onClick={handleInputClick}
                      value={searchTerm}
                      onChange={(e) => {
                        console.log('searchTerm', e.target.value)
                        setSearchTerm(e.target.value)
                      }}
                      placeholder="Procurar..."
                      type="text"
                    />
                    <DropdownDivider />
                    <DropdownHeader icon="tags" content="Tabulações" />
                    <DropdownMenu scrolling>
                      {convertToFullPathList(tabulations, '')
                        .filter((item) =>
                          item.nome
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase()),
                        )
                        .map((option) => (
                          <DropdownItem
                            key={option.id}
                            value={option.id}
                            text={option.nome}
                            active={option.id === tabulacao}
                            style={{
                              backgroundColor:
                                option.id === tabulacao ? '#d2d2d2' : '#fff',
                            }}
                            onClick={() => {
                              const findTabulacao = convertToFullPathList(
                                tabulations,
                                '',
                              ).find((item) => item.id === option.id)

                              if (findTabulacao?.use_template) {
                                setComentario(findTabulacao.texto_template)
                                setTimeout(() => {
                                  ajustarAlturaTextAreas()
                                }, 0)
                              }

                              setTabulacaoLocal(option.id)
                            }}
                          />
                        ))}
                    </DropdownMenu>
                  </DropdownMenu>
                </Dropdown>
              </ContainerTabulacao>
            </div>

            <Divider />

            {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
            <label>Arquivos</label>
            <div>
              <input type="file" multiple hidden />
              <Button
                type="button"
                color="blue"
                onClick={() => {
                  const input = document.querySelector('input[type="file"]')
                  input.click()
                  input.onchange = async (e) => {
                    const files = e.target.files
                    const formData = new FormData()

                    let total = 0
                    for (let i = 0; i < files.length; i++) {
                      const findFile = ticket.files.find(
                        (file) =>
                          file.file_name === files[i].name &&
                          file.size === files[i].size,
                      )
                      if (findFile) {
                        toast.error(`Arquivo ${files[i].name} já existe`, {
                          autoClose: false,
                        })
                        continue
                      }

                      total++
                      formData.append('files', files[i])
                    }

                    if (total > 0) {
                      setIsUploading(true)
                      setUploadProgress(0)

                      try {
                        await api.post(
                          `tickets/${ticket.id}/upload`,
                          formData,
                          {
                            headers: {
                              'Content-Type': 'multipart/form-data',
                            },
                            onUploadProgress: (progressEvent) => {
                              const percentCompleted = Math.round(
                                (progressEvent.loaded * 100) /
                                  progressEvent.total,
                              )
                              setUploadProgress(percentCompleted)
                            },
                          },
                        )

                        getTicket()
                      } catch (error) {
                        toast.error(
                          'Erro ao fazer upload do arquivo. O limit para arquivo 50MB.',
                          { autoClose: false },
                        )
                        console.error('Upload failed:', error)
                      } finally {
                        setIsUploading(false)
                        input.value = ''
                        setUploadProgress(0)
                      }
                    }
                    input.value = ''
                  }
                }}
                disabled={isUploading}
              >
                {isUploading ? 'Enviando...' : 'Anexar arquivos'}
              </Button>
            </div>
            <div
              style={{
                width: '150px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {isUploading && (
                <div
                  style={{
                    marginTop: '10px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      width: '100%',
                      backgroundColor: '#e0e0e0',
                      borderRadius: '4px',
                      marginBottom: '5px',
                    }}
                  >
                    <div
                      style={{
                        width: `${uploadProgress}%`,
                        height: '10px',
                        backgroundColor: '#3b82f6',
                        borderRadius: '4px',
                        transition: 'width 0.3s ease',
                      }}
                    />
                  </div>
                  <span>{uploadProgress}%</span>
                </div>
              )}
            </div>
            {ticket.files && ticket.files.length > 0 && (
              <Table celled striped>
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell colSpan="3">
                      Arquivos anexados
                    </TableHeaderCell>
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {ticket.files.map((file) => {
                    return (
                      <TableRow key={file.id}>
                        <TableCell collapsing>
                          <Icon name="file outline" /> {file.file_name}
                        </TableCell>
                        <TableCell>
                          {(file.size / 1024).toFixed(2)} Kb
                        </TableCell>
                        <TableCell collapsing textAlign="right">
                          <Button
                            type="button"
                            color="blue"
                            onClick={async () => {
                              const { data } = await api.get(
                                `tickets/${ticket.id}/download/${file.id}`,
                              )

                              window.open(data.url, '_blank')
                            }}
                          >
                            Download
                          </Button>
                          <Button
                            type="button"
                            color="red"
                            onClick={async () => {
                              await api.delete(
                                `tickets/${ticket.id}/delete/${file.id}`,
                              )

                              getTicket()
                            }}
                          >
                            Remover
                          </Button>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            )}
            <Divider />

            <Form.TextArea
              id="textAreaCommentEdit"
              name="comentario"
              label="Comentarios da ligação"
              placeholder="detalhes da chamada..."
              value={comentario || ''}
              onChange={(e) => {
                setComentario(e.target.value)
                ajustarAlturaTextAreas()
              }}
            />

            <Button primary fluid type="submit">
              Alterar
            </Button>
          </Message>

          <TicketComments id_ticket={id} />
        </Form>
      ) : (
        <Loader active />
      )}
    </FormContainer>
  )
}

Ticket.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
}
